import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
// Material Imports
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles"; //Limitless imports

import { withi18n } from "../../hocs/i18n";
import DialogueBody from "../../dialogue-body/DialogueBody";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import TimePosted from "../../time-posted/TimePosted";
var useStyles = makeStyles({
  dialogueContainer: {
    width: "100%"
  },
  marginText: {
    marginTop: 16
  }
});

var ExpertDialogue = function ExpertDialogue(_ref) {
  var t = _ref.t,
      isReported = _ref.isReported,
      message = _ref.message,
      dialogue = _ref.dialogue,
      rest = _objectWithoutProperties(_ref, ["t", "isReported", "message", "dialogue"]);

  var classes = useStyles();
  var author = dialogue.author,
      body = dialogue.body,
      created = dialogue.created,
      userId = dialogue.userId;
  var expertInfo = message.expertAuthors[userId];
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, Object.assign({
    author: author,
    expertInfo: expertInfo
  }, rest), function (expertClasses) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.dialogueContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(expertClasses.listItem, " ").concat(expertClasses.expertBackground)
    }, /*#__PURE__*/React.createElement(DialogueBody, {
      body: body,
      textStyling: isReported ? expertClasses.blurText : expertClasses.expertText,
      linkify: !isReported
    }), author && /*#__PURE__*/React.createElement(Typography, {
      className: "".concat(expertClasses.expertText, " ").concat(classes.marginText),
      variant: "caption"
    }, author && t("Posted by {0}", author)), expertInfo && /*#__PURE__*/React.createElement(Typography, {
      className: expertClasses.expertText,
      variant: "caption"
    }, t("{0} answers | {1}% rating", expertInfo.answerCount, expertInfo.rating))), created && /*#__PURE__*/React.createElement("div", {
      className: expertClasses.responseTime
    }, /*#__PURE__*/React.createElement(TimePosted, {
      time: created
    })));
  });
};

export default withi18n(ExpertDialogue);
ExpertDialogue.defaultProps = {
  isReported: false
};